<div style="padding: 24px; max-width: 1200px; margin: 0 auto;">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
    <h2 style="margin: 0;">QA Playground — Test Sales Orders</h2>
    <button mat-raised-button color="primary" (click)="createNew()">
      <mat-icon>add</mat-icon> Create New Test Order
    </button>
  </div>

  <mat-card>
    <table mat-table [dataSource]="dataSource" matSort style="width: 100%;">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let row">{{row.id}}</td>
      </ng-container>
      <ng-container matColumnDef="tripId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Trip ID</th>
        <td mat-cell *matCellDef="let row">{{row.tripId}}</td>
      </ng-container>
      <ng-container matColumnDef="tripReference">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Reference</th>
        <td mat-cell *matCellDef="let row">{{row.tripReference}}</td>
      </ng-container>
      <ng-container matColumnDef="mainClientName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Client</th>
        <td mat-cell *matCellDef="let row">{{row.mainClientName}}</td>
      </ng-container>
      <ng-container matColumnDef="tripStartDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Trip Start</th>
        <td mat-cell *matCellDef="let row">{{row.tripStartDate | date:'shortDate'}}</td>
      </ng-container>
      <ng-container matColumnDef="isCancelled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Cancelled</th>
        <td mat-cell *matCellDef="let row">
          <mat-icon *ngIf="row.isCancelled" color="warn">cancel</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="dateCreated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
        <td mat-cell *matCellDef="let row">{{row.dateCreated | date:'short'}}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="warn" (click)="deleteOrder(row.id, $event)" matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          (click)="openOrder(row.id)"
          style="cursor: pointer;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>

    <div *ngIf="dataSource.data.length === 0" style="padding: 24px; text-align: center; color: #888;">
      No test sales orders yet. Click "Create New Test Order" to start.
    </div>
  </mat-card>
</div>
